export enum TEMPERATURE_UNITS {
  CELSIUS = 'C',
  FAHRENHEIT = 'F',
}

export enum PRESSURE_UNITS {
  KILO_PASCAL = 'kPa',
  POUNDS_PER_SQUARE_INCH = 'psi',
}
